var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.20876 10.9946H17.3788L14.4988 8.11461C14.1088 7.72461 14.1088 7.09461 14.4988 6.70461C14.8888 6.31461 15.5188 6.31461 15.9088 6.70461L20.4988 11.2946C20.8888 11.6846 20.8888 12.3146 20.4988 12.7046L15.9088 17.2946C15.5188 17.6846 14.8888 17.6846 14.4988 17.2946C14.1088 16.9046 14.1088 16.2746 14.4988 15.8846L17.3788 12.9946H4.20876C3.65876 12.9946 3.20876 12.5446 3.20876 11.9946C3.20876 11.4446 3.65876 10.9946 4.20876 10.9946Z",
    fill: "#0061AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.0e2c66a2e925b7d7c0f2df3032d399b6.svg";
export { ForwardRef as ReactComponent };